import * as React from 'react';
import Box from '@mui/material/Box';
import { useState, useEffect } from 'react';
import { Link as RouterLink, useRouteLoaderData, redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import palette from 'src/theme/palette';

// material
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  Modal,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

// components
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import { RoleModal } from '../sections/@dashboard/role';
import { api } from '../Api';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';

export default function Rolepermission() {
  const [permission, setpermission] = useState([]);
  const { t } = useTranslation();

  const requirement = ['visible', 'add', 'edit', 'delete'];

  function checkRender() {
    let check = 'Role/Permissions';
    const localPerm = JSON.parse(localStorage.getItem('permissions'))?.filter(
      (item) => item.permission_name.toLowerCase() == check.toLowerCase()
    );

    localPerm?.length > 0 &&
      localPerm[0]?.permission_types.filter((items) =>
        requirement.includes(items?.permission_type_name?.toLowerCase())
          ? setpermission((permissions) => [
              ...permissions,
              items?.permission_type_name?.toLowerCase()
            ])
          : false
      );
  }
  useEffect(() => {
    checkRender();
  }, []);

  const [list, setlist] = useState([]);
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel, item) => () => {
    if (panel === expanded) {
      setExpanded(false);
      setroleDetails(null);
    } else {
      setroleDetails({
        name: item.role_name,
        id: item.id
      });
      setExpanded(panel);
    }
  };

  function getRoles() {
    setloadingTable(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');

    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.getRoles, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        setlist(result.data);
      })
      .catch((error) => console.log('error', error))
      .finally(() => {
        setloadingTable(false);
      });
  }

  useEffect(() => {
    getRoles();
  }, []);

  const style = {
    minWidth: '80%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',
    pt: 2,
    px: 2,
    border: '2px solid',
    borderColor: palette.primary.main,
    borderRadius: 1
  };

  const [adminModal, setadminModal] = useState(false);
  const handleAdminClose = () => setadminModal(false);
  const refreshAdmin = () => {
    setDeleteModal(false);
    setadminModal(false);
    getRoles();
  };

  //DELETE MANJAN
  const [DeleteModal, setDeleteModal] = React.useState(false);

  const handleClickOpenDeleteModal = () => {
    setDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
  };

  const [roleDetails, setroleDetails] = useState(null);
  const [loading, setloading] = useState(false);

  function DeleteRole() {
    setloading(true);
    const myHeaders = new Headers();
    const token = localStorage.getItem('token');

    myHeaders.append('Authorization', `Bearer ${token}`);

    var requestOptions = {
      method: 'DELETE',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.delete_roles + '?id=' + roleDetails.id, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        } else {
          throw new Error('Failed to delete role');
        }
      })
      .then((result_) => {
        const result = JSON.parse(result_);
        refreshAdmin();
      })
      .catch((error) => console.log('error', error))
      .finally(() => setloading(false));
  }

  const [loadingTable, setloadingTable] = useState(false);

  const [edit, setedit] = useState(false);

  // if (permission.length > 0) {
  return (
    <Page title={`Role/Permissions | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Stack
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: 'row',
          pr: 2
        }}
      >
        <Typography
          sx={{
            fontSize: 25,
            fontFamily: 'poppinsSemiBold',
            padding: '0 10px 0 10px',
            marginBottom: 1.5
          }}
        >
          Role/Permissions
        </Typography>
        {/* {permission.includes('add') && ( */}
        <Button
          variant="contained"
          onClick={() => {
            setedit(false);
            setadminModal(true);
          }}
          startIcon={<Iconify icon="ic:round-plus" style={{ fontSize: 19, marginRight: -5 }} />}
          sx={{
            fontSize: 12,
            color: palette.primary.primary,
            fontFamily: 'poppinsLight',
            borderRadius: 0.7,
            width: 105
          }}
        >
          Add Role
        </Button>
        {/* )} */}
      </Stack>

      {/* ROLE/PERMISSION Modal */}
      <Dialog
        fullWidth
        maxWidth="lg"
        open={adminModal}
        onClose={handleAdminClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          {/* <Box sx={style}> */}
          <RoleModal
            handleClose={handleAdminClose}
            refresh={refreshAdmin}
            edit={edit}
            roleid={roleDetails}
          />
          {/* </Box> */}
        </DialogContent>
      </Dialog>
      {/* ROLE/PERMISSION Modal End */}

      {/* Delete Modal */}
      <Dialog open={DeleteModal} onClose={handleCloseDeleteModal}>
        <DialogContent sx={{ display: 'flex', width: 500 }}>
          <Box
            sx={{
              backgroundColor: '#FEE2E2',
              borderRadius: 100,
              height: 40,
              width: 40,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Iconify icon={'typcn:warning-outline'} style={{ fontSize: 25, color: 'red' }} />
          </Box>

          <Box sx={{ ml: 2, flex: 1 }}>
            <DialogContentText
              sx={{ color: palette.primary.titledark, fontFamily: 'poppinsMedium', fontSize: 18 }}
            >
              Delete Role
            </DialogContentText>
            <DialogContentText
              sx={{
                color: palette.primary.tittableHeadTitleledark,
                fontFamily: 'poppinsRegular',
                fontSize: 12,
                flex: 1
              }}
            >
              {`Are you sure you want to delete ${roleDetails?.name} role？`}
            </DialogContentText>
            <Box
              sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', mt: 2 }}
            >
              <LoadingButtonWrapper
                onClick={() => {
                  DeleteRole();
                }}
                loading={loading}
                variant="contained"
                sx={{
                  backgroundColor: '#DC2626',
                  width: loading ? 120 : 90,
                  height: 30,
                  fontSize: 12,
                  borderRadius: 0.7,
                  fontFamily: 'poppinsLight',
                  letterSpacing: 0.3,
                  transition: 'width 0.3s ease, background-color 0.3s ease, transform 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#b91c1c'
                  }
                }}
                title="Delete"
              />

              <Button
                onClick={handleCloseDeleteModal}
                variant="outlined"
                sx={{
                  ml: 1.5,
                  color: palette.primary.pageButtonTitle,
                  borderColor: palette.primary.pageButtonBorder,
                  fontSize: 12,
                  fontFamily: 'poppinsRegular',
                  borderRadius: 0.7,
                  '&:hover': {
                    backgroundColor: palette.primary.inputborder,
                    borderColor: palette.primary.pageButtonBorder
                  }
                }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {/* Delete Moda End */}

      <Card sx={{ mx: 1.5 }}>
        <Typography
          sx={{
            fontSize: 20,
            fontFamily: 'poppinsSemiBold',
            padding: '15px 10px 15px 15px'
          }}
        >
          Roles
        </Typography>
        <Scrollbar>
          {list.map((item, index) => {
            let expand = expanded === index ? true : false;
            return (
              <Accordion
                key={index}
                expanded={expand}
                onChange={handleChange(index, item)}
                style={{
                  borderRadius: 0,
                  margin: 0,
                  borderTop: expand && '1px solid #919eab3d'
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <Iconify icon="mdi:chevron-down" sx={{ color: palette.primary.main }} />
                  }
                  sx={{
                    paddingY: 0.5,
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}
                >
                  <Typography
                    sx={{
                      flexGrow: 1,
                      fontFamily: !expand ? 'poppinsRegular' : 'poppinsSemiBold',
                      fontSize: 13,
                      mt: 0.8
                    }}
                  >
                    {item.role_name} ({item.role_count})
                  </Typography>
                  {item.role_count == 0 && permission.includes('delete') && (
                    <IconButton
                      size="small"
                      onClick={(event) => {
                        event.stopPropagation();
                        setroleDetails({
                          name: item.role_name,
                          id: item.id
                        });
                        handleClickOpenDeleteModal();
                      }}
                      edge="end"
                      sx={{ ml: 1 }}
                    >
                      <Iconify color="red" icon={'mdi:trash-can'} />
                    </IconButton>
                  )}
                </AccordionSummary>

                <AccordionDetails
                  style={{
                    backgroundColor: expand && palette.primary.lighterMain,
                    borderTop: expand && '1px solid #919eab3d',
                    paddingTop: 20,
                    paddingBottom: 30
                  }}
                >
                  <div
                    style={{
                      flexDirection: 'row',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center'
                    }}
                  >
                    <Typography
                      sx={{
                        width: '33%',
                        flexShrink: 0,
                        fontFamily: !expand ? 'poppinsRegular' : 'poppinsSemiBold',
                        fontSize: 16,
                        color: palette.primary.main
                      }}
                    >
                      Permissions :
                    </Typography>
                    {/* {permission.includes('edit') && ( */}
                    <Button
                      variant="contained"
                      onClick={() => {
                        setedit(true);
                        setadminModal(true);
                      }}
                      startIcon={
                        <Iconify
                          icon="material-symbols:edit-note-rounded"
                          style={{ fontSize: 19, marginRight: -5 }}
                        />
                      }
                      sx={{
                        fontSize: 12,
                        color: palette.primary.primary,
                        fontFamily: 'poppinsLight',
                        borderRadius: 0.7,
                        width: 65
                      }}
                    >
                      Edit
                    </Button>
                    {/* )} */}
                  </div>

                  {item?.permissions.map((perm, permIndex) => {
                    const hasSubRoutes = perm?.subRoutes && perm?.subRoutes.length > 0;

                    return (
                      <Box
                        key={permIndex}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          flex: 1,
                          py: hasSubRoutes ? 1.5 : 0,
                          pl: 2,
                          pr: 2,
                          mb: 1,
                          ...(hasSubRoutes && {
                            backgroundColor: palette.primary.lighterMain,
                            borderRadius: 1,
                            borderLeft: '3px solid',
                            borderColor: 'primary.main',
                            px: 2,
                            pt: 2
                          })
                        }}
                      >
                        {/* Parent Permission Heading */}
                        {hasSubRoutes && (
                          <Typography
                            sx={{
                              fontFamily: hasSubRoutes ? 'poppinsSemiBold' : 'poppinsRegular',
                              fontSize: hasSubRoutes ? 14 : 12,
                              color: hasSubRoutes ? palette.primary.main : palette.text.primary,
                              textTransform: hasSubRoutes ? 'uppercase' : 'none',
                              marginBottom: hasSubRoutes ? 1 : 0
                            }}
                          >
                            {perm?.permission_name} {hasSubRoutes && '/'}
                          </Typography>
                        )}

                        {/* If NO subRoutes → simple row */}
                        {!hasSubRoutes && (
                          <div
                            style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                          >
                            <Typography
                              sx={{
                                width: 150,
                                fontFamily: 'poppinsSemiBold',
                                fontSize: 12
                              }}
                            >
                              {perm?.permission_name} :
                            </Typography>

                            {perm?.permission_types?.map((ptype, pIndex) => (
                              <div
                                key={pIndex}
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  marginLeft: 20
                                }}
                              >
                                {/* {pIndex === 0 && ':'} */}
                                <Iconify
                                  icon="tabler:checkbox"
                                  style={{
                                    marginRight: 3,
                                    marginLeft: pIndex === 0 && 3,
                                    color: palette.primary.main
                                  }}
                                />
                                <Typography
                                  sx={{
                                    fontSize: 11,
                                    whiteSpace: 'nowrap',
                                    fontFamily: 'poppinsRegular'
                                  }}
                                >
                                  {ptype?.permission_type_name}
                                </Typography>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* If subRoutes → nested rows inside card */}
                        {hasSubRoutes &&
                          perm?.subRoutes.map((sub, subIndex) => (
                            <div
                              key={subIndex}
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                padding: '4px 0',
                                paddingLeft: 30
                              }}
                            >
                              <Typography
                                sx={{
                                  width: 150,
                                  fontFamily: 'poppinsSemiBold',
                                  fontSize: 12
                                }}
                              >
                                {sub?.permission_name} :
                              </Typography>

                              {sub?.permission_types.map((ptype, pIndex) => (
                                <div
                                  key={pIndex}
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    marginLeft: '3%'
                                  }}
                                >
                                  <Iconify
                                    icon="tabler:checkbox"
                                    style={{
                                      marginRight: 3,
                                      marginLeft: pIndex === 0 && 3,
                                      color: palette.primary.main
                                    }}
                                  />
                                  <Typography
                                    sx={{
                                      fontSize: 11,
                                      whiteSpace: 'nowrap',
                                      fontFamily: 'poppinsRegular'
                                    }}
                                  >
                                    {ptype?.permission_type_name}
                                  </Typography>
                                </div>
                              ))}
                            </div>
                          ))}
                      </Box>
                    );
                  })}
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Scrollbar>
        {loadingTable && (
          <Box
            py={5}
            style={{
              display: 'flex',
              justifyContent: 'center',
              flex: 1
            }}
          >
            <CircularProgress />
          </Box>
        )}
      </Card>
    </Page>
  );
  // } else {
  //   return null;
  // }
}
